import React, { useState } from 'react';
import { useBrandConfig } from '../../../context/BrandConfigContext';

const defaultFaqs = [
  {
    id: 1,
    question: 'What is this promotion about?',
    answer:
      'This is a promotional campaign where you can participate to win amazing prizes. Enter your unique code, provide your details, and stand a chance to win exciting rewards.'
  },
  {
    id: 2,
    question: 'Who can participate?',
    answer:
      'The campaign is open to eligible residents. Please refer to the full terms and conditions for eligibility requirements, including age restrictions and employee exclusions.'
  },
  {
    id: 3,
    question: 'How do I enter the competition?',
    answer:
      "It's easy:\n(i) Purchase any qualifying product\n(ii) Find your unique promotional code\n(iii) Register your details on this platform\n(iv) Enter your unique code\n(v) Stand a chance to win amazing prizes. Every entry brings you closer to winning!"
  },
  {
    id: 4,
    question: 'What prizes can I win?',
    answer:
      'There are lots of exciting rewards up for grabs! Cash prizes and instant rewards are available. Check the prizes section for full details on available rewards.'
  },
  {
    id: 5,
    question: 'Is there an age limit?',
    answer: 'Yes. You must be 18 years or older to enter. Please see full terms and conditions for more details.'
  },
  {
    id: 6,
    question: 'Which products qualify for the promo?',
    answer:
      'Look for participating products with promotional codes. Check product packaging for campaign branding and promotion details to confirm eligibility.'
  },
  {
    id: 7,
    question: 'How many times can I enter?',
    answer: 'Each unique code = one entry. The more valid codes you enter, the more chances you have to win exciting prizes.'
  },
  {
    id: 8,
    question: 'When does the competition end?',
    answer: 'Please refer to the terms and conditions or the campaign details on this platform for the promotion start and end dates.'
  }
];

/**
 * FaqAccordion — global widget.
 * Priority: explicit `items` prop > brand-config `faq_items` > hardcoded defaults.
 */
const FaqAccordion = ({ items, introText } = {}) => {
  const brand = useBrandConfig();
  const [openAccordion, setOpenAccordion] = useState(null);

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  const faqs = items?.length > 0 ? items : brand?.faq_items?.length > 0 ? brand.faq_items : defaultFaqs;

  return (
    <div className="container">
      <div className="card white-card border-0 rounded-3 mx-auto mb-4">
        <div className="card-body text-center">
          <p className="font-light" style={{ fontSize: '0.75em' }}>
            {introText ||
              "Find answers to the most common questions about this campaign below.\nIf you need further assistance or have a question that isn't covered here, please feel free to contact our Support Team"}
          </p>
        </div>
      </div>

      <div className="accordion dz-accordion custom-style" id="accordionFaq1">
        {faqs.map((faq, index) => (
          <div key={faq.id} className="accordion-item">
            <h1 className="accordion-header" id={`heading${faq.id}`}>
              <button
                className={`accordion-button ${openAccordion === index ? '' : 'collapsed'}`}
                type="button"
                onClick={() => toggleAccordion(index)}
                aria-expanded={openAccordion === index}
                aria-controls={`collapse${faq.id}`}
              >
                {String(faq.id).padStart(2, '0')}. {faq.question}
              </button>
            </h1>
            <div
              id={`collapse${faq.id}`}
              className={`accordion-collapse collapse ${openAccordion === index ? 'show' : ''}`}
              aria-labelledby={`heading${faq.id}`}
            >
              <div className="accordion-body">
                <div
                  className="m-b0 font-light rich-text-content"
                  style={{ fontSize: '0.85em', whiteSpace: 'pre-line' }}
                  dangerouslySetInnerHTML={{ __html: faq.answer }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqAccordion;
